// extracted by mini-css-extract-plugin
export default {"pause":"iBeS","c":"NB5b"};